import {
  signInWithEmailAndPassword,
  signInWithPopup,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signOut as firebaseSignOut,
} from "firebase/auth";
import { auth } from "@/lib/firebase";
import { resetContinueUrl } from "@/lib/authErrors";

const googleProvider = new GoogleAuthProvider();

export async function signInWithEmail(email: string, password: string) {
  return signInWithEmailAndPassword(auth, email, password);
}

export async function signInWithGoogle() {
  return signInWithPopup(auth, googleProvider);
}

export async function sendPasswordReset(email: string) {
  // WP3: without ActionCodeSettings the Firebase-hosted handler page has no way
  // back into the app after the password is set.
  return sendPasswordResetEmail(auth, email, {
    url: resetContinueUrl(window.location.origin),
    handleCodeInApp: false,
  });
}

export async function signOut() {
  sessionStorage.removeItem("impersonation");
  return firebaseSignOut(auth);
}
